import { HTMLAttributes } from 'react'

import cn from '@/utils/tailwind/cn'

export const FormsAnalyticsCardMetric = ({
  className,
  ...props
}: HTMLAttributes<HTMLDivElement>) => (
  <div
    className={cn('mt-2 text-2xl font-bold text-gray-900', className)}
    {...props}
  />
)
